<template>
  <header
    class="flex items-center justify-between relative lg:py-0 container mx-auto h-22"
  >
    <div class="z-50 relative">
      <NuxtLink :to="{ name: 'home' }" :aria-label="$texts('home', 'Home')">
        <SpriteSymbol
          name="logo"
          alt="AOZ logo"
          class="aspect-[101/35] h-9 text-red page-landing:text-white"
        />
      </NuxtLink>
    </div>

    <VuepalTransitionHeight>
      <div
        v-show="isMenuOpen"
        class="lg:!flex max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:size-full bg-darkGreenOverlay z-50 lg:static lg:w-auto lg:h-full lg:left-auto lg:bg-transparent"
      >
        <div>
          <PageHeaderGlobalMenu
            class="relative mt-14 lg:mt-0 lg:fixed lg:right-10 top-4 container mx-auto"
          />
          <PageHeaderServiceMenu />
        </div>
      </div>
    </VuepalTransitionHeight>

    <div class="lg:invisible ml-auto lg:ml-0 w-28 flex justify-end z-50">
      <PageHeaderMenuButton v-model="isMenuOpen" class="menuToggleButton" />
    </div>
  </header>
</template>

<script setup lang="ts">
const isMenuOpen = ref(false)

// Close mobile menu when route changes
const route = useRoute()
watch(
  () => route.path,
  () => {
    isMenuOpen.value = false
  },
)

// Disable body scrolling when mobile menu is open
watch(isMenuOpen, (isOpen) => {
  if (import.meta.client) {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }
})

// Clean up on component unmount
onUnmounted(() => {
  if (import.meta.client) {
    document.body.style.overflow = ''
  }
})
</script>
